<proffeo-ui-page-wrapper>
  <div
    pageActions
    class="flex w-full justify-between"
  >
    <proffeo-ui-input
      (debouncedValueChange)="searchValue.set($event)"
      [debounceMs]="300"
      variant="search"
      placeholder="placeholders.search-input"
    />
    <proffeo-ui-button
      (clicked)="openCreateProjectTagDialog()"
      variant="accent"
      text="add-new"
      fontIcon="add"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="openCreateProjectTagDialog()"
      variant="accent"
      fontIcon="add"
      class="fixed bottom-5 right-5 lg:bottom-10 lg:right-10 z-10"
    ></proffeo-ui-button>
  </div>
  <div class="w-full pt-3 lg:pt-6">
    <div
      [proffeoSpinner]="projectTags() === undefined"
      proffeoSpinnerSize="lg"
      class="flex min-h-48 w-full flex-col gap-2 sm:overflow-x-auto sm:rounded-md sm:border sm:border-proffeo-border sm:bg-proffeo-surface"
    >
      @if (projectTags()) {
        <proffeo-project-tags-list
          [tags]="filteredItems()"
          class="w-full"
        ></proffeo-project-tags-list>
      }
    </div>
  </div>
</proffeo-ui-page-wrapper>
